export class PriceListProductPerioid {
  id: number;
  idPerioid: number;
  enabled: boolean;
}
